import {inject, injectable} from 'inversify';

import type {Nullable} from '../../../utils/utility-types';
import type {FetchMediaRequest} from '../../models/CachedMedia/FetchMediaRequest/FetchMediaRequest';

import {CachedMediaDbService} from '../../system/cachedMediaDB/CachedMediaDb.service';
import {RemoteFileStorageService} from '../../system/remoteFileStorage/RemoteFileStorage.service';

@injectable()
export class SaveMediaToCachedMediaDbUseCase {
  constructor(
    @inject(CachedMediaDbService)
    private readonly dbService: CachedMediaDbService,
    @inject(RemoteFileStorageService)
    private readonly remoteFileStorageService: RemoteFileStorageService,
  ) {}

  async exec(url: string, request: FetchMediaRequest, ext?: Nullable<string>) {
    const urlId = this.remoteFileStorageService.url.getId(url, ext);
    const cachedUrl = await this.dbService.getCachedUrl(urlId);

    if (!cachedUrl) {
      const response = await request.exec(url);

      const blob = await response.blob();

      try {
        await this.dbService.add(urlId, blob);
      } catch (error) {
        // most likely we have exceeded the quota
        this.dbService.clear();

        throw error;
      }
    }

    return this.dbService.getCachedUrl(urlId);
  }
}
